import {
  useAnimatedClass,
  Icon,
  ToolTip,
  useTranslation,
  usePopstateListener,
} from '@testsigma/atoms';
import classNames from 'classnames';

export interface TestDataDrawerHelpInfoProps {
  description: string;
  url: string;
}

interface TestDataDrawerLayoutProps {
  title: string;
  symbol: string | React.ReactNode;
  onClose: (item?: any) => void;
  children: React.ReactNode;
  helpInfo?: TestDataDrawerHelpInfoProps;
  footer?: React.ReactNode;
  className?: string;
}

export const TestDataDrawerLayout: React.FC<TestDataDrawerLayoutProps> = ({
  helpInfo,
  title,
  symbol,
  onClose,
  children,
  footer,
  className,
}) => {
  const { t } = useTranslation();
  const animationClass = useAnimatedClass('reval-animation-opacity');
  // Hook to close the drawer when the user navigates to another page using browser action
  usePopstateListener(onClose);

  return (
    <div className={classNames('flex flex-col h-screen', className)}>
      <div className='bg-secondary-50 px-4 py-3 flex font-semibold text-base flex-shrink-0'>
        <div className='flex-grow mr-4 flex'>
          <span className='bg-neutral-200 rounded-border-radius-button w-6 h-6 mx-1 inline-flex item-center justify-center flex-shrink-0 text-secondary-700'>
            {symbol}
          </span>
          <span className='text-secondary-700 ml-1 group'>{title}</span>
          {helpInfo && (
            <div className='group flex'>
              <Icon
                name='help'
                className='cursor-pointer text-lg text-secondary-400 hover:text-primary-500 pl-md'
              />
              <div className='invisible absolute group-hover:visible bg-[#252c33] text-[#f7f8f9] text-2xs py-2 px-1.5 rounded-md font-normal ml-[-120px] !leading-3.5 mt-5'>
                <div className={'max-w-xs'}>
                  {helpInfo.description}
                  <span className='mx-1'>{t('modal.help.more_info')}</span>
                  <a
                    target='_blank'
                    href={helpInfo.url}
                    className='text-primary-400 cursor-pointer'
                    rel='noreferrer'>
                    {t('common.click_here')}
                  </a>
                </div>
              </div>
            </div>
          )}
        </div>
        <ToolTip
          placement={'bottom'}
          content={t('modal.close')}
          className='inline-flex'>
          <Icon
            name='close'
            className='cursor-pointer text-2xl'
            onClick={onClose}
            data-test-data-close
          />
        </ToolTip>
      </div>
      <div
        className={classNames(
          'flex-1 overflow-y-auto bg-white',
          animationClass,
        )}>
        {children}
      </div>
      {footer && <div className='flex-shrink-0'>{footer}</div>}
    </div>
  );
};